export const SUPPORTED_LOCALES = ["gl", "es", "en"];

export function normalizeLocale(locale) {
  if (typeof locale !== "string") {
    return "";
  }

  return locale.toLowerCase().split(/[-_]/)[0];
}

export function getBrowserLocale(fallback = "es") {
  if (typeof navigator === "undefined") {
    return fallback;
  }

  const preferredLocales = Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages
    : [navigator.language, navigator.userLanguage].filter(Boolean);

  for (const locale of preferredLocales) {
    const normalizedLocale = normalizeLocale(locale);
    if (SUPPORTED_LOCALES.includes(normalizedLocale)) {
      return normalizedLocale;
    }
  }

  return fallback;
}

export function getInitialLocale(fallback = "es") {
  if (typeof localStorage !== "undefined") {
    const savedLocale = normalizeLocale(localStorage.getItem("language"));
    if (SUPPORTED_LOCALES.includes(savedLocale)) {
      return savedLocale;
    }
  }

  return getBrowserLocale(fallback);
}
